import GuiContext from "config/context/guiContext";
import { useContext, useState } from "react";
import { useReadComposition } from "./useReadComposition";
import { useCompositionsContext } from "../context/CompositionsContext";
import { useGetCompositionScopesService } from "./useGetCompositionScopesService";
import EncryptionContext from "config/context/encryptionContext";

const initialServerStatus = {
    response: null,
    loading: false,
    error: null,
}

export const useInsertRowsService = () => {
    const { encryption } = useContext(EncryptionContext);
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { readComposition } = useReadComposition();
    const { getCompositionScopes } = useGetCompositionScopesService();
    const { selectedComposition } = useCompositionsContext();
    const {
        selected: { selectedAccount, selectedServer },
        URL
    } = useContext(GuiContext);

    const insertRows = async ({ permission, private_key, composition, rowsData }) => {
        setLoading(true);
        try {
            const scopeToUse = (selectedComposition?.selected_scope || selectedAccount || "");
            const res = await fetch(`${URL}/api/database/insert`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    database: selectedAccount || "",
                    server_url: selectedServer || "",
                    scope: scopeToUse,
                    permission: permission,
                    private_key: private_key,
                    encryption: encryption || false,
                    encryption_key: "",
                    composition: composition,
                    data: rowsData
                }),
            });

            const data = await res.json();
            setResponse(data);
            if (data?.status) {
                getCompositionScopes({ composition });
                readComposition({ composition });
                return true;
            }
            if (!data?.status) {
                setError(data?.message);
                return false;
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
            return false;
        } finally {
            setLoading(false);
        }
    }

    const resetServerStatus = () => {
        setLoading(initialServerStatus.loading);
        setResponse(initialServerStatus.response);
        setError(initialServerStatus.error);
    }

    return {
        response,
        loading,
        error,
        insertRows,
        resetServerStatus
    }
}